<template>
	<div class="content news-content">
		<div class="pub-inner-head"></div>
		<innerTop :text="$t(pageTitle)"></innerTop>
		<template v-if="$route.query.pageType != 'release'">
			<div class="news-top">
				<div class="news-top-item" v-for="(v, index) in topList" :key="index" @click="openDetail(v)">
					<img :src="(v['topCoverUrl' + En] || v['topCoverUrl']) ? (v['topCoverUrl' + En] || v['topCoverUrl']) + '?x-image-process=image/resize,w_1200,limit_0' : defaultImg" />
					<div class="text">
						<span class="span ellipsis3">
							<i>{{ $t('top') }}</i>
							{{ v['name' + En] }}
						</span>
						<div class="des">
							<span v-for="t in v.tagList" :key="t.nameEn">{{ t['name' + En] || t['name'] }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="totop"></div>
		</template>
		<div class="main_page_content">
			<div class="left-tabs-wrapper">
				<div class="left-tabs">
					<div class="tab" :class="active == item.lableValue ? 'active' : ''" v-for="(item, index) in tabs" :key="index" @click="tabFn(item)">{{ item['lableDesc' + En] }}</div>
				</div>
			</div>
			<div class="m">
				<!-- <div class="match_title">
					<div class="name">
						<div></div>
						<span>{{ $t(pageTitle) }}</span>
					</div>
				</div> -->
				<div class="forum_list">
					<ul>
						<li v-for="v in list" :key="v.uuid" @click="openDetail(v)">
							<a href="javascript:void(0)">
								<div class="pic"><img :src="(v['coverUrl' + En] || v['coverUrl']) ? (v['coverUrl' + En] || v['coverUrl']) + '?x-image-process=image/resize,w_1200,limit_0' : defaultImg" /></div>
								<div class="grow">
									<p>{{ v['name' + En] || v['name'] }}</p>
									<div class="des" v-if="isPc">
										<span v-for="t in v.tagList" :key="t.nameEn">{{ t['name' + En] || t['name'] }}</span>
									</div>
									<div class="des" v-else>
										<span v-for="t in v.tagList && v.tagList.slice(0, 3)" :key="t.nameEn">{{ t['name' + En] || t['name'] }}</span>
									</div>
									<div class="text" v-html="v['content' + En]"></div>
									<!-- <div class="bot">
										<img src="../../assets/images/forum_06.jpg" />
										<em>{{ sliceStr(v.releaseTime) }}</em>
									</div> -->
								</div>
							</a>
						</li>
					</ul>
					<pagination :total="total" :currentPage="currentPage" @currentChange="currentChange" style="transform: translateX(-0.15rem)"></pagination>
				</div>
			</div>
		</div>
		<!-- <display></display> -->

	</div>
</template>

<script>
import protal from "@/api/protal";
import display from '@/components/display';
import { mapState } from "vuex";
export default {
	name: 'news_publish',
	data() {
		return {
			flagtop: false,
			total: 0,
			currentPage: 1,
			list: [],
			uuid: '',
			url: 'getWebQueryList',
			defaultImg: require('@/assets/images/default-img.png'),
			detailTitle: '新闻',
			tabs: [],
			active: '',
			topList: []
		}
	},
	components: {
		display
	},
	created() {
		if (location.href.includes('goodNews_page')) {
			this.pageView('ciif_medServices_goodNews', { newsViewFrom_var: '无' })
		} else {
			this.pageView('ciif_newsList', { newsViewFrom_var: '无' })
		}
		this.getWebQueryList()
		this.getZdType()
		this.getWebQueryTopList()
	},
	watch: {
		$route: {
			handler() {
				if (this.$route.path == '/news_publish') {
					this.getWebQueryList()
				}
			},
			deep: true
		},
        En() {
            this.currentPage = 1
            this.getWebQueryList()
        }
	},
	computed: {
		...mapState({
			ExhibitDetail: state => state.ExhibitDetail
		}),
		pageTitle() {
			if (this.$route.query.pageType == 'release') {
				return 'fa'
			} else if (this.$route.query.pageType == 'events') {
				return 'events'
			} else {
				return 'xin'
			}
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll)
	},
	methods: {
		// 查询首页置顶新闻列表
		getWebQueryTopList() {
			let that = this
			protal.queryWebNewsList({
				"pageNum": 1,
				"pageSize": 3,
				// "recommendSts": 0,
				// "topSts": 0
			}).then(r => {
				this.topList = r.data
			})
		},
		tabFn(item) {
			this.active = item.lableValue
			this.currentPage = 1
			this.getWebQueryList()
		},
		getZdType() {
			if (this.$route.query.pageType == 'release') {
				protal.getZdType('release_tag').then(r => {
					this.tabs = [{ lableDesc: '全部', lableDescEn: 'ALL', lableValue: '' }, ...r.data]
				})
			} else {
				protal.getZdType('new_tag').then(r => {
					this.tabs = [{ lableDesc: '全部', lableDescEn: 'ALL', lableValue: '' }, ...r.data]
				})
			}
		},
		// 打开详情页
		openDetail(v) {
			this.$store.commit('setPageName', {
				name: this.detailTitle + '详情',
				nameEn: 'News Details',
			})
			this.openMatch({ path: '/match_process', query: { pageType: this.$route.query.pageType, uuid: v.uuid } }, v)
			
			if (location.href.includes('goodNews_page')) {
				this.$jsAPI('track', 'ciif_medServices_goodNewsList', {
					contentID_var: v.uuid,
					contentName_var: v.name,
					labelName_var: v.tagList.map(x => x.name).join(','),
					publishSource_var: v.source,
				})
			} else {
				this.$jsAPI('track', 'ciif_newsListClick', {
					contentID_var: v.uuid,
					contentName_var: v.name,
					labelName_var: v.tagList.map(x => x.name).join(','),
					publishSource_var: v.source,
				})
			}
		},
		// 翻页事件
		currentChange(e) {
			this.currentPage = e
			this.getWebQueryList()
		},
		// 查询首页置顶新闻列表
		getWebQueryList() {
			this.url = 'getWebQueryList'
			this.detailTitle = '新闻'
			let params = {
				"pageNum": this.currentPage,
				"pageSize": 10,
			}
			if (this.$route.query.pageType == 'release') {
				params.type = this.active
			} else {
				params.tag = this.active
			}
			if (this.ExhibitDetail.uuid) {
				params.exhibitUuid = this.ExhibitDetail.uuid
			}
			if (this.$route.query.pageType == 'goodNews') {
				// 好新闻评选
				this.$store.commit('setHeadIndex', 4)
				params.recommendSts = 0
			} else if (this.$route.query.pageType == 'moreNews') {
				this.$store.commit('setHeadIndex', 1)
                params.topSts = 0
			} else if (this.$route.query.pageType == 'release') {
				this.$store.commit('setHeadIndex', 1)
				this.url = 'queryWebReleaseList'
				this.detailTitle = '发布'
			} else if (this.$route.query.pageType == 'exhibitNews') {
				this.$store.commit('setHeadIndex', 0)
				this.url = 'getExhibitNewsList'
			} else if (this.$route.query.pageType == 'events') {
				this.$store.commit('setHeadIndex', 0)
				this.url = 'queryWebActivityList'
				this.detailTitle = '活动'
			}
			protal[this.url](params).then(r => {
				this.list = (r.data || []).map(x => {
					if (this.detailTitle === '活动') {
						x.releaseTime = `${ x.activityDate } ${ x.activityStartTime }-${ x.activityEndTime }`
					}
					return x
				})
				this.total = r.total
			})
		},
		handleScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			if (scrollTop > 100) {
				this.flagtop = true
			} else {
				this.flagtop = false
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},

	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.content {
		background-color: #F7F8F9;
	}

	.left-tabs {
		position: absolute;
		left: 140px;
		top: 254px;
		width: 300px;
		border-top: 1px solid rgba(11, 36, 63, 0.5);
		padding-top: 30px;

		.tab {
			font-family: sy;
			font-weight: 400;
			font-size: 20px;
			color: #0B243F;
			line-height: 36px;
			text-align: left;
			font-style: normal;
			margin-bottom: 28px;
			cursor: pointer;
			transition: 0.3s;

			&:hover, &.active {
				font-weight: bold;
				font-size: 28px;
				color: #F4501C;
			}
		}
	}

	.totop {
		margin-top: -174px;
	}

	.news-top {
		padding-top: 254px;
		display: flex;
		width: 1640px;
		margin: 0 auto;
		position: relative;
		z-index: 1;

		.news-top-item {
			width: 532px;
			height: 607px;
			background: #FFFFFF;
			border-radius: 24px;
			padding-top: 16px;
			margin-right: 20px;
			cursor: pointer;

			&:last-child {
				margin-right: 0;
			}

			img {
				display: block;
				margin: 0 auto;
				width: 500px;
				height: 375px;
				object-fit: cover;
				object-position: center top;
			}

			.text {
				width: 500px;
				font-family: Inter, syn;
				font-weight: 600;
				font-size: 28px;
				color: #000000;
				line-height: 36px;
				text-align: left;
				font-style: normal;
				margin: 0 auto;

				.span {
					display: block;
					height: 108px;
					margin: 28px auto 20px;

					i {
						height: 36px;
						background: #F4501C;
						border-radius: 4px;
						padding: 0 10px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 26px;
						color: #FFFFFF;
						line-height: 1;
						text-align: left;
						font-style: normal;
						vertical-align: middle;
						display: inline-flex;
						align-items: center;
						transform: translateY(-2px);
					}
				}

				.des {
					display: flex;
					
					span {
						padding: 0 12px;
						height: 36px;
						border-radius: 18px;
						border: 1px solid #999999;
						margin-right: 6px;
						font-family: Inter, syn;
						font-weight: 400;
						font-size: 16px;
						color: #666666;
						line-height: 16px;
						text-align: left;
						font-style: normal;
						display: inline-flex;
						align-items: center;
					}
				}
			}
		}
	}

	.main_page_content {
		width: 100%;
		overflow: hidden;
		background-color: #F7F8F9;
		padding: 254px 0 120px 0;
		min-height: 100vh;
		position: relative;

		.m {
			width: 11.2rem;
			margin-left: 660px;

			.forum_list {
				width: 100%;
				border-top: 1px solid #999999;

				ul {
					width: 100%;

					&::-webkit-scrollbar {
						width: 4px;
					}

					&::-webkit-scrollbar-track {
						background: #CFCFCF;
					}

					&::-webkit-scrollbar-thumb {
						background-color: #626262;
						border-radius: 20px;
					}

					li {
						border-bottom: 1px solid #999999;
						width: 100%;

						a {
							display: flex;
							padding: .24rem 0;
							justify-content: space-between;
							box-sizing: border-box;

							.pic {
								width: 360px;
								overflow: hidden;
								height: 270px;
								border-radius: 24px;
								order: 2;
								margin-left: 80px;

								img {
									display: block;
									width: 100%;
									height: 100%;
									object-fit: cover;
									object-position: center top;
								}
							}

							.grow {
								overflow: hidden;
								width: calc(100% - 2.56rem - .4rem);
								position: relative;

								.bot {
									display: flex;
									align-items: center;
									position: absolute;
									left: 0;
									bottom: 0;
									width: 100%;

									img {
										border-radius: 50%;
										display: block;
										width: .14rem;
										min-width: 12px;
										margin-right: .08rem;
									}

									em {
										font-size: .16rem;
										color: #999999;
										font-family: syn;
									}
								}

								.des {
									display: flex;
									align-items: center;
									flex-wrap: wrap;

									span {
										display: inline-flex;
										align-items: center;
										height: .24rem;
										border-radius: .5rem;
										padding: 0 .12rem;
										font-size: .16rem;
										color: #666666;
										margin-right: .08rem;
										border: 1px solid #CBCCCC;
										line-height: 1;
										font-family: syn;
										margin-top: .16rem;
									}
								}

								p {
									font-size: 28px;
									color: #222222;
									font-family: syb;
									line-height: 36px;
								}

								.text {
									margin-top: 24px;
									font-family: MiSans, MiSans;
									font-weight: 400;
									font-size: 19px;
									color: #666666;
									line-height: 30px;
									text-align: left;
									font-style: normal;
									display: -webkit-box !important;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
									overflow: hidden !important;
								}
							}

							&:hover {

								.grow {

									p {
										color: #F4501C;
									}
								}
							}
						}
					}
				}
			}

			.match_title {
				overflow: hidden;
				.name {
					display: flex;
					margin-bottom: .32rem;
					align-items: center;
					div {
						width: .09rem;
						border-radius: 20px;
						background: #FC581C;
						margin-right: .27rem;
						height: .36rem;
					}

					span {
						font-size: .36rem;
						color: #fff;
						display: block;
						line-height: 1;
						font-family: syb;
						letter-spacing: .01rem;
					}
				}

				em {
					display: block;
					font-size: .2rem;
					color: #fff;
					line-height: 1;
					font-family: sy;
					letter-spacing: .01rem;
					padding-left: .4rem;
					margin-bottom: .2rem;
				}
			}
		}
	}
}
@media screen and (max-width: 768px) {
	.content {
		background-color: #F7F8F9;
	}

	.left-tabs-wrapper {
		width: 7.14rem;
		overflow: auto;
		margin-left: 0.36rem;

		&::-webkit-scrollbar {
			width: 0;
			height: 0;
		}
	}

	.left-tabs {
		display: inline-flex;
		padding-right: 1px;

		.tab {
			font-family: sy;
			font-weight: 400;
			font-size: .26rem;
			height: 1.04rem;
			color: #0B243F;
			line-height: 1;
			text-align: left;
			font-style: normal;
			cursor: pointer;
			display: flex;
			align-items: center;
			transition: 0.3s;
			margin-right: .4rem;

			&:hover, &.active {
				font-weight: bold;
				font-size: .36rem;
				color: #F4501C;
			}
		}
	}

	.news-top {
		width: 6.78rem;
		margin: 0 auto;
		position: relative;
		z-index: 1;

		.news-top-item {
			width: 100%;
			background: #FFFFFF;
			border-radius: .28rem;
			padding-top: .2rem;
			padding-bottom: .24rem;
			cursor: pointer;
			margin-bottom: .32rem;

			&:last-child {
				margin-right: 0;
			}

			img {
				display: block;
				margin: 0 auto;
				width: 6.38rem;
				height: 4.78rem;
				object-fit: cover;
				object-position: center top;
			}

			.text {
				width: 6.38rem;
				font-family: Inter, syn;
				font-weight: 600;
				font-size: .29rem;
				color: #000000;
				line-height: .4rem;
				text-align: left;
				font-style: normal;
				margin: 0 auto;

				.span {
					display: block;
					margin: .25rem auto .28rem;
					padding-top: 0.05rem;

					i {
						height: .4rem;
						background: #F4501C;
						border-radius: .08rem;
						padding: 0 .13rem;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: .28rem;
						color: #FFFFFF;
						line-height: 1;
						text-align: left;
						font-style: normal;
						vertical-align: middle;
						display: inline-flex;
						align-items: center;
						transform: translateY(-0.04rem);
					}
				}

				.des {
					display: flex;
					
					span {
						padding: 0 .24rem;
						height: .44rem;
						border-radius: .22rem;
						border: 1px solid #999999;
						margin-right: .08rem;
						font-family: Inter, syn;
						font-weight: 400;
						font-size: .2rem;
						color: #666666;
						line-height: 1;
						text-align: left;
						font-style: normal;
						display: inline-flex;
						align-items: center;
					}
				}
			}
		}
	}

	.main_page_content {
		width: 100%;
		overflow: hidden;
		background-color: #F7F8F9;
		padding: 0.46rem 0 1.2rem 0;
		position: relative;

		.m {
			width: 6.78rem;
			margin: 0 auto;

			.forum_list {
				width: 100%;
				border-top: 1px solid #999999;

				ul {
					width: 100%;

					&::-webkit-scrollbar {
						width: 4px;
					}

					&::-webkit-scrollbar-track {
						background: #CFCFCF;
					}

					&::-webkit-scrollbar-thumb {
						background-color: #626262;
						border-radius: 20px;
					}

					li {
						border-bottom: 1px solid #999999;
						width: 100%;

						a {
							display: flex;
							padding: .32rem 0 .4rem;
							justify-content: space-between;
							box-sizing: border-box;

							.pic {
								width: 2.4rem;
								overflow: hidden;
								height: 1.8rem;
								border-radius: .24rem;
								order: 2;
								margin-left: .28rem;

								img {
									display: block;
									width: 100%;
									height: 100%;
									object-fit: cover;
									object-position: center top;
								}
							}

							.grow {
								overflow: hidden;
								width: calc(100% - 2.56rem - .4rem);
								position: relative;

								.bot {
									display: flex;
									align-items: center;
									position: absolute;
									left: 0;
									bottom: 0;
									width: 100%;

									img {
										border-radius: 50%;
										display: block;
										width: .14rem;
										min-width: 12px;
										margin-right: .08rem;
									}

									em {
										font-size: .16rem;
										color: #999999;
										font-family: syn;
									}
								}

								.des {
									display: flex;
									align-items: center;
									flex-wrap: wrap;
									margin-top: .2rem;

									span {
										display: inline-flex;
										align-items: center;
										height: .44rem;
										border-radius: .22rem;
										padding: 0 .24rem;
										font-size: .2rem;
										color: #666666;
										margin-right: .08rem;
										border: 1px solid #CBCCCC;
										line-height: 1;
										font-family: syn;
									}
								}

								p {
									font-size: .28rem;
									color: #222222;
									font-family: syb;
									line-height: .36rem;
									-webkit-line-clamp: 4;
								}

								.text {
									display: none;
								}
							}

							&:hover {

								.grow {

									p {
										color: #F4501C;
									}
								}
							}
						}
					}
				}
			}

			.match_title {
				overflow: hidden;
				.name {
					display: flex;
					margin-bottom: .32rem;
					align-items: center;
					div {
						width: .09rem;
						border-radius: 20px;
						background: #FC581C;
						margin-right: .27rem;
						height: .36rem;
					}

					span {
						font-size: .36rem;
						color: #fff;
						display: block;
						line-height: 1;
						font-family: syb;
						letter-spacing: .01rem;
					}
				}

				em {
					display: block;
					font-size: .2rem;
					color: #fff;
					line-height: 1;
					font-family: sy;
					letter-spacing: .01rem;
					padding-left: .4rem;
					margin-bottom: .2rem;
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/news_publish/publish.vue